import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dateTimeFormatter } from '../../../../../Assests/Utility';
import { sagaActions } from '../../../../../../sagas/sagaActions';
import { getTruckSelector } from '../../../../../../redux/reducers/reducerSlices/getTruckReducer';
import { getCommentsListSelector } from '../../../../../../redux/reducers/reducerSlices/CommentsReducerSlice';
import CommentRow from './CommentRow/CommentRow';
import { format } from 'date-fns';
import './CommentsListSection.css';
import _ from "lodash"
import { getLoadSelector } from '../../../../../../redux/reducers/reducerSlices/getLoadReducer';

const CommentsListSection = (props) => {

    const dispatch = useDispatch();
    const { load_control_num, themeSelected } = props;
    const commentsList = useSelector(getCommentsListSelector);
    const getTruck = useSelector(getTruckSelector);
    const { truckListMasterData, subscriptionTruckData, isSubscriptionUpdate } = getTruck;
    const getLoad = useSelector(getLoadSelector);
    const { selectedLoad } = getLoad;
    const selectedLoadRef = useRef();

     useEffect(() => {
            if (selectedLoad) {
                selectedLoadRef.current = selectedLoad
            } else {
                selectedLoadRef.current = null
            }
        },[selectedLoad])
    
    useEffect(() => {
        if (isSubscriptionUpdate) {
            if (subscriptionTruckData?.data?.load_control_num === selectedLoadRef?.current?.load_control_num) {
                dispatch({
                    type: sagaActions.GET_ALL_COMMENTS, payload: {
                    'load_control_num': subscriptionTruckData?.data?.load_control_num
                } });
            }
        } else {
             const paramsObj = { 'load_control_num': load_control_num };
             dispatch({ type: sagaActions.GET_ALL_COMMENTS, payload: paramsObj });
        }
    }, [truckListMasterData]);

    const tableRow = () => {
        let arr = [];
        if (_.size(commentsList)) {
             arr = commentsList.map((element,i) => {
                 let dateFinal = '';
                if(element.create_date){
                const commentDate = dateTimeFormatter(new Date(element.create_date))
                const formattedDate = (format(new Date(commentDate.date), 'MMM, dd'))
                dateFinal = commentDate.time + ' ' + ordinal(formattedDate)
                }
                return <CommentRow key={element.create_date || i} name={element.created_by} comment={element.notes_text} date={dateFinal || '-'} themeSelected={themeSelected} />
            });
        }
        return arr;
    }

    const ordinal = (n) => {
        var s = ["th", "st", "nd", "rd"];
        var v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    return (
        <div className={`container-fluid d-flex justify-content-start m-0 p-0`}>
            <table>
                <thead />
                <tbody className='commentsTableBody container-fluid m-0 p-0'>{tableRow()}</tbody>
            </table>
        </div>
    )

}

export default CommentsListSection;